// extracted by mini-css-extract-plugin
module.exports = {"container":"item_container__RRG4h","column":"item_column__48xjc"};